import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { TimetableResponse, PostTimetableOption, GetTimetableOption, Link } from '../models/timetables.model';
import * as error from '../../shared/components/error-summary/error-handler.function';
@Injectable()
export class TimetableService {
    constructor(private http: Http) { }

    getTimetable(origin: string, destination: string, departAfter: string, arriveBy: string): Observable<TimetableResponse> {
        return this.http.post('/umbraco/api/travel/GetTimetable',
            new GetTimetableOption(origin, destination, departAfter, arriveBy))
            .map(res => res.json())
            .map(r => Object.assign(new TimetableResponse(), r))
            .catch(error.handleError);
    }

    postTimetable(postTimetableOption: Array<PostTimetableOption>, timetableDate: string) {
        const url = `/umbraco/api/travel/PostTimetable`,
            options = {
                serviceDetails: postTimetableOption,
                serviceDate: timetableDate
            };
        return this.http.post(url, options)
            .map(res => res.json())
            .catch(error.handleError);
    }

    getDocumentsTimetables(): Observable<Link[]> {
        return this.http.get('/umbraco/api/travel/GetDocumentsTimetables')
            .map(res => res.json())
            .map(list => list.map(i => Object.assign(new Link(), i)))
                .catch(error.handleError);
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/timetable-service.ts